import { SvgIcon, type SvgIconProps } from '@mui/material';

// Geometry is verbatim from that file, with two adjustments for this context:
//  - the viewBox is padded out from `-5 -5 34 34` so the r=17 disc stops bleeding to the edge and
//    lands on the same ~83%-of-box footprint as MuiSvgIcon's filled circles, which keeps it from
//    outsizing its neighbours;
//  - the centre is scaled down about its own bbox centre. At full size it reads much heavier here
//    than in the brand mark, where the white ring carries the weight instead of dropping out. 0.72
//    is eyeballed against the brand mark's ring-to-centre balance — safe to nudge.
const MONAD_CENTRE_SCALE = 0.72;
// centre of the centre subpath's bbox (x 5.14..18.86, y 4.74..18.86), so scaling doesn't shift it
const CENTRE_X = 12;
const CENTRE_Y = 11.8;

const MONAD_DISC = 'M12 -5A17 17 0 1 0 12 29A17 17 0 1 0 12 -5Z';
const MONAD_RING =
  'M11.9999 0C8.53463 0 0 8.5344 0 11.9999C0 15.4655 8.53463 24 11.9999 24C15.4652 24 24 15.4653 24 11.9999C24 8.53455 15.4654 0 11.9999 0Z';
const MONAD_CENTRE =
  'M10.13 18.8619C8.66865 18.4637 4.73986 11.5913 5.13812 10.13C5.53639 8.66858 12.4087 4.73984 13.87 5.1381C15.3313 5.5363 19.2602 12.4087 18.8619 13.8701C18.4636 15.3314 11.5913 19.2602 10.13 18.8619Z';

export function MonadNavIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="-8.5 -8.5 41 41" {...props}>
      <path fillRule="evenodd" d={`${MONAD_DISC}${MONAD_RING}`} />
      <path
        d={MONAD_CENTRE}
        transform={`translate(${CENTRE_X} ${CENTRE_Y}) scale(${MONAD_CENTRE_SCALE}) translate(${-CENTRE_X} ${-CENTRE_Y})`}
      />
    </SvgIcon>
  );
}
